import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "el"],
    fallbackLng: "en",

    // English sentence as key
    keySeparator: false,
    nsSeparator: false,
    interpolation: { escapeValue: false },

    // we use one file
    ns: ["translation"],
    defaultNS: "translation",

    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
      // no-cache = revalidation με ETag σε κάθε load: 304 όταν δεν άλλαξαν,
      // φρέσκο αρχείο αμέσως μετά από deploy (αλλιώς ο browser σερβίρει
      // παλιές μεταφράσεις από heuristic cache για ώρες).
      requestOptions: { cache: "no-cache" },
    },

    detection: {
      order: ["querystring", "localStorage", "navigator"],
      caches: ["localStorage"],
      lookupQuerystring: "lng",
    },

    react: { useSuspense: false },
  });

export default i18n;
